export default "__VITE_ASSET__4KMhJOYK__"